<template>
  <div class="form-title">
    <h3 class="form-title__title">{{ title }}</h3>
    <HelpTooltip
      v-if="getTooltipText || getTooltipImage"
      class="form-title__additional-info"
      :text="getTooltipText"
      :image="getTooltipImage"
      :image-alt="getTooltipImageAlt"
      :width="getTooltipWidth"
      :icon-color="getIconColor"
      :icon-hover-color="getIconHoverColor"
    />
  </div>
</template>

<script>
import { default as HelpTooltip } from '@/shared/ui/form/help-tooltip';

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    tooltip: {
      type: Object,
      default: null,
    },
  },
  components: { HelpTooltip },
  computed: {
    getTooltipText() {
      return this.tooltip?.text || null;
    },
    getTooltipImage() {
      return this.tooltip?.image || null;
    },
    getTooltipImageAlt() {
      return this.tooltip?.imageAlt || null;
    },
    getTooltipWidth() {
      return this.tooltip?.width || null;
    },
    getIconColor() {
      return this.tooltip?.iconColor || '#E4E4E7';
    },
    getIconHoverColor() {
      return this.tooltip?.iconHoverColor || '#000000';
    },
  },
};
</script>

<style scoped lang="scss">
.form-title {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #F6F6F9;
  padding: 16px 10px;
  margin-bottom: 16px;
  border-radius: 4px;

  &__title {
    font-size: 16px;
    font-weight: 500;
    color: #09090B;
    text-align: center;
  }

  &__additional-info {
    margin-left: 8px;
  }
}
</style>
